// extracted by mini-css-extract-plugin
export default {"passwordFormModel":"PasswordChangeModal_passwordFormModel__pzbBx","formBtnsProfile":"PasswordChangeModal_formBtnsProfile__QSlS-"};